// 引入axios
import axios from "axios";
import router from "@/router";
import store from "@/store";

let host = window.location.origin;
let instance = axios.create({
    // baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 60000
});
instance.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

// 添加请求拦截器
instance.interceptors.request.use(function(config) {
    // 基本地址
    if (config.url.startsWith('console')) {
        config.url = config.url.replace('console', '')
        config.baseURL = process.env.VUE_APP_CONSOLE
    } else if (config.url.startsWith('laidanapp')) {
        config.url = config.url.replace('laidanapp', '')
        config.baseURL = process.env.VUE_APP_LAIDANAPP
        const token = localStorage.getItem('laidanToken')
        if (token) {
            config.headers.Authorization = token;
        }
    } else if (config.url.startsWith('pointsme')) {
        config.url = config.url.replace('pointsme', '')
        config.baseURL = process.env.VUE_APP_POINTSME
    } else {
        config.baseURL = host
    }
    config.headers["Accept-Language"] = localStorage.getItem('Language');
    config.headers["X-Client-Type"] = "web-laidan";
    config.headers["X-Client-Version"] = "3.0.0";
    // 设备ID
    if (localStorage.getItem('deviceId')) {
        config.headers["X-Device-Id"] = localStorage.getItem('deviceId');
    }
    config.headers["X-User-Id"] = localStorage.getItem('userId') ? localStorage.getItem('userId') : '';
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    let code = response.data.code;
    if (Number(code) === 40001) {
        const routerName = router.currentRoute.name
        store.commit('saveLoginBeforeRouter', routerName)
        setTimeout(() => {
            router.replace({path: '/login'})
        }, 1000)
    }
    return response.data;
}, function (error) {
    return Promise.reject(error);
});

export default instance;
